export default {
  outPlatformCopy: {
    common: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      walletAccountLabel: 'Wallet account:',
      amountRangeHint: 'Amount {min} - {max} USD',
      viewCopy: 'View Copy',
      securityVerifyTitle: 'Security Verification',
      securityVerifyTip: 'Used to verify your account, ensure safe operation',
      tradingPassword: 'Trading Password',
      inputPlaceholder: 'Please input',
      noField: 'N/A',
      validation: {
        fundPasswordRequired: 'Please enter trading password',
        amountRequired: 'Please enter amount',
        agreementRequired: 'Please check the agreement',
      },
    },
    notifications: {
      copyStoppedSuccess: { title: 'Operation Success', desc: 'Stopped copying successfully' },
      copyStoppedFailed: { title: 'Operation Failed', desc: 'Stop copy request failed' },
      shareUrlCopySuccess: { title: 'Copy Success', desc: 'Share link copied' },
      shareUrlCopyFailed: { title: 'Copy Failed', desc: 'Share link copy failed' },
      startCopySuccess: { title: 'Operation Success', desc: 'Copy started successfully' },
      startCopyFailed: { title: 'Operation Failed', desc: 'Your copy request failed' },
      addCopySuccess: { title: 'Operation Success', desc: 'Investment added successfully' },
      addCopyFailed: { title: 'Operation Failed', desc: 'Your add investment request failed' },
    },
    stopCopy: {
      successTitle: 'Stop Copy Success',
      estimatedEarnings: 'Estimated profit',
    },
    copySuccess: {
      title: 'Copy Success',
      followedPrefix: 'You have successfully followed “',
      followedSuffix: '”, copy multiplier ',
      percentSign: '%',
    },
    mtSelect: {
      placeholder: 'Please select account',
      platformAccount: 'Platform Account',
      thirdPartyAccount: 'Third-party Account',
    },
    copyAccount: {
      noAvailable: 'No available copy accounts',
      noCurrent: 'No current account',
      occupied: 'Used',
      available: 'Available',
      floating: 'Floating',
    },
    signalCard: {
      follow: 'Follow',
      earningRate: 'Earning Rate',
      maxDrawdown: 'Max Drawdown',
      riskLevel: 'Risk Level',
      profitShare: 'Profit Share',
      recommend: 'Recommend',
    },
    startCopy: {
      title: 'Start Copy',
      investAmountTitle: 'Investment Amount',
      agreementPrefix: 'By clicking “Confirm”, I have read, understood and agree',
      agreementName: '“Entrusted Copy Trading Service Agreement”',
      successInvestedFormat: 'You have successfully invested {amount} USD',
      validation: {
        minTip: 'Minimum investment is {min} USD',
        maxTip: 'Maximum investment is {max} USD',
      },
    },
    addCopy: {
      title: 'Add Funds',
      addAmountTitle: 'Add Amount',
      successTitle: 'Add Funds Success',
      successAddedFormat: 'You have successfully added {amount} USD',
      validation: {
        minTip: 'Minimum investment is {min} USD',
        maxTip: 'Maximum investment is {max} USD',
      },
    },
    shareCopy: {
      earningRate: 'Earning Rate',
      totalProfit: 'Total P/L',
      maxDrawdown: 'Max Drawdown',
      riskLevel: 'Risk Level',
      equity: 'Equity',
      inviteCode: 'Invite Code',
      dataPeriod: 'Data Period',
      displayIndicators: 'Display Indicators',
      downloadImage: 'Download Image',
      copyLink: 'Copy Link',
      sendEmail: 'Send Email',
      facebook: 'Facebook',
      twitter: 'Twitter',
      ranges: {
        year: '1 Year',
        days7: '7 Days',
        days30: '30 Days',
        days60: '60 Days',
        days90: '90 Days',
        days180: '180 Days',
      },
    },
    unsetFundPassword: {
      title: 'Account Security Reminder',
      tip: 'To protect your funds, set a trading password before following signals.',
      setNow: 'Set Now',
    },
    unHaveMt: {
      title: 'Account Opening',
      tip: 'After the first successful deposit, a real MT account will be created automatically',
      depositNow: 'Deposit Now',
    },
    unKyc: {
      title: 'Profile Incomplete',
      tip: 'Please complete profile verification to unlock this feature.',
      completeNow: 'Complete Now',
    },
    followConfig: {
      title: 'Edit Configuration',
      account: {
        balance: 'Balance',
        available: 'Available',
        occupied: 'Used',
        floatingPL: 'Floating P/L',
      },
      species: {
        title: 'Symbols',
        all: 'All',
        inputPlaceholder: 'Enter symbol',
      },
      duration: {
        title: 'Subscription Duration',
        add: 'Add Duration',
        units: {
          month: 'USD / month',
          season: 'USD / quarter',
          halfYear: 'USD / half-year',
          year: 'USD / year',
        },
      },
      info: {
        title: 'Copy Info',
        directForward: 'Forward Copy',
        directBackward: 'Reverse Copy',
        suffix: 'x',
        inputTimesPlaceholder: 'Enter multiplier',
        minTip:
          'Minimum multiplier 0.01 represents 1.00%. If below minimum lot size, order at minimum lot.',
      },
      sltp: {
        title: 'Take Profit / Stop Loss',
        optional: '(Optional)',
        stopLossPlaceholder: 'Stop Loss Amount',
        takeProfitPlaceholder: 'Take Profit Amount',
      },
      match: {
        title: 'Matching Rules',
        optional: '(Optional)',
        index: 'No.',
        signalSuffix: 'Signal Suffix',
        signalSymbol: 'Signal Symbol',
        mySuffix: 'My Suffix',
        mySymbol: 'My Symbol',
        selectSignalSuffix: 'Select signal suffix',
        selectMySuffix: 'Select my suffix',
        selectSignalSymbol: 'Select signal symbol',
        selectMySymbol: 'Select my symbol',
        noSuffix: 'No Suffix',
        modeSuffixMatch: 'Suffix Match',
        modeExactMatch: 'Exact Match',
      },
      validation: {
        timesRequired: 'Please enter copy multiplier',
      },
      notifications: {
        updateSuccess: { title: 'Updated', desc: 'Your copy configuration was updated successfully' },
      },
    },
    completeFollow: {
      title: 'Complete Orders',
      totalProfit: 'Total P/L',
      signalId: 'Signal ID',
      earningRate: 'Earning Rate',
      followProfit: 'Copy Profit',
      listTitle: 'Copy List',
      selectedFormat: 'Selected {selected}/{total}',
      sideBuy: 'Buy',
      sideSell: 'Sell',
      lotsSuffix: 'Lots',
      table: {
        symbol: 'Symbol',
        cmd: 'Type/Volume',
        openPrice: 'Open Price',
        currentPrice: 'Current Price',
        time: 'Time',
      },
      notifications: {
        noneSelected: { title: 'No Orders Selected', desc: 'Please select orders to submit' },
        success: { title: 'Submit Success', desc: 'Your completion submission succeeded' },
      },
    },
    archive: {
      title: 'Archive Signal',
      irreversible: 'This action cannot be undone',
      agreeText: 'I have read and agree',
      steps: {
        prepare: { title: 'Signal Preparation', desc: 'There are open positions. Please close all orders first.' },
        submit: { title: 'Submit Request', desc: 'Confirm and understand the result of archiving' },
        next: {
          title: 'What happens next?',
          details: [
            'New investors: This signal will no longer be investable',
            'Existing investors: All active investments will be closed. The signal will be view-only.',
            'For you: All active investments will be closed. Performance fees settle at the end of the period.',
            'The signal will be view-only',
          ],
        },
      },
      notifications: {
        cancelSuccess: { title: 'Success', desc: 'Signal archived successfully' },
      },
    },
    charts: {
      pie: { category: 'Symbols' },
      monthSuffix: 'Month',
    },
  },
}